import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { withRouter } from "react-router-dom";
import { find } from "lodash";

import Info from "../components/organization/Info";
import Header from "../components/ContainerHeader";
import UsersAndPackages_forUserOrganization from "../components/organization/UsersAndPackages_forUserOrganization";

import { getUserOrganizations } from "../actions/resourceActions";
import { getHost } from "../actions/resourceActions";

import {DebugElement, DebugElementBegin, DebugElementEnd} from "../Atollon/debug";
import {isInstanceUserDetailOnThisPath} from "../Atollon/pages/InstanceUserDetail/shared";
import {InstanceUserDetailAsReduxObject} from "../Atollon/pages/InstanceUserDetail/InstanceUserDetail";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const UserOrganization = ( inputProps ) => {

    let { match, history, userOrganizations, location } = inputProps;
  const organization = find(userOrganizations, o => o.id === match.params.id);

  if (isInstanceUserDetailOnThisPath(location))
  {
      return (
          <div>
              <DebugElement text="containers/UserOrganization.js - USER"/>
              <InstanceUserDetailAsReduxObject {...inputProps} />
          </div>
      );
  }
  else if (organization)
  {
      const server = organization.server;
      const host = '???';

      //console.log('UserOrganization','match',match,'location',location);

      return (
          <div className="flex-col">
              <DebugElement text="containers/UserOrganization.js - BEGIN"/>

              <TouchPageHeader title={organization.name}/>
              <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

              <Info organization={organization}/>

              {/* ={history} host={host} server={server} */}
              <UsersAndPackages_forUserOrganization organization={organization} />

              <DebugElement text="containers/UserOrganization.js - END"/>
          </div>
      );
  }
  else
  {
      return (
          <div>
              <DebugElement text="containers/UserOrganization.js - PASS"/>
          </div>
      );
  }
};

export default compose(
  withRouter,
  connect(
    inputState => {

        let { resource: { userOrganizations } } = inputState;

        return {userOrganizations};
    },
    { getUserOrganizations, getHost }
  ),
  lifecycle({
    async componentWillMount() {
      const { getHost, getUserOrganizations, match } = this.props;

      await getUserOrganizations(match.params.id);
      await getHost();
    }
  })
)(UserOrganization);



// WEBPACK FOOTER //
// ./src/pages/UserOrganization.js